import actionTypes from 'modules/clients/actions/actionTypes';

const INITIAL_STATE = {
  loading: false,
  success: false,
  error: false,
};

const resendReceipt = (state = INITIAL_STATE, { type }) => {
  switch (type) {
    case actionTypes.RESEND_RECEIPT_LOADING:
      return {
        loading: true,
        error: false,
        success: false,
      };

    case actionTypes.RESEND_RECEIPT_SUCCESS:
      return {
        loading: false,
        error: false,
        success: true,
      };

    case actionTypes.RESEND_RECEIPT_ERROR:
      return {
        loading: false,
        error: true,
        success: false,
      };

    default:
      return state;
  }
};

export default resendReceipt;
